module.exports = __webpack_public_path__ + "img/partner_vodafone.95809601.png";